import React from 'react';
import { Bell } from 'lucide-react';

// La cloche de la barre du haut. Elle n'interroge plus le serveur elle-même :
// le compteur vit une seule fois dans AdministrationLayout
// (useNotificationCounter), qui le lui passe, comme au tiroir. La pastille est
// arrondie comme les boutons et s'élargit avec le nombre (min-w, px).
const NotificationBadge = ({ onClick, unreadCount = 0, className = "" }) => {
  return (
    <button
      onClick={onClick}
      className={`p-2 hover:bg-white/10 rounded-lg relative transition-colors ${className}`}
      type="button"
      // Le bouton reste cliquable au-dessus de la barre
      style={{
        pointerEvents: 'auto',
        position: 'relative',
        zIndex: 1
      }}
    >
      <Bell size={22} className="text-white" />
      {unreadCount > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 bg-red-500 rounded-lg flex items-center justify-center text-xs font-bold text-white"
          // La pastille ne doit pas bloquer les clics
          style={{
            pointerEvents: 'none',
            userSelect: 'none'
          }}
        >
          {unreadCount}
        </span>
      )}
    </button>
  );
};

export default NotificationBadge;
